import React, { useMemo } from "react";

import TableContainer from "../../Components/Common/TableContainer";
import { QuoteDetailsPayload } from "types/quote.api";

interface QuoteSummaryProps {
  quoteDetails: QuoteDetailsPayload;
}

const QuoteSummaryList: React.FC<QuoteSummaryProps> = ({ quoteDetails }) => {
  const columns = useMemo(
    () => [
      {
        header: "ITEM NAME",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <span className="fw-normal text-black2D fs-14 font-primary">
            {cell.getValue()}
          </span>
        ),
      },
      {
        header: "CATEGORY",
        accessorKey: "category_name",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <span className="fw-normal text-black2D fs-14 font-primary">
            {cell.getValue() ? cell.getValue() : "-"}
          </span>
        ),
      },
      {
        header: "SUBCATEGORY",
        accessorKey: "subcategory_name",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <span className="fw-normal text-black2D fs-14 font-primary">
            {cell.getValue() ? cell.getValue() : "-"}
          </span>
        ),
      },
      {
        header: "QUANTITY",
        accessorKey: "quantity",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => {
          const rowdata = cell.row.original;
          return (
            <span className="fw-normal text-black2D fs-14 font-primary">
              {cell.getValue()} {rowdata.unit}
            </span>
          );
        },
      },
      {
        header: "PRICE/UNIT",
        accessorKey: "price",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <span className="fw-normal text-black2D fs-14 font-primary">
            £{cell.getValue().toFixed(2)}
          </span>
        ),
      },
      {
        header: "UNIT COST",
        accessorKey: "cost",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <span className="fw-normal text-black2D fs-14 font-primary">
            £{cell.getValue().toFixed(2)}
          </span>
        ),
      },
      {
        header: "TOTAL",
        accessorKey: "total_price",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <span className="fw-normal text-black2D fs-14 font-primary">
            £{cell.getValue().toFixed(2)}
          </span>
        ),
      },
    ],
    []
  );

  return (
    <div id="quoteList" className="pb-2 custom-border-box">
      <TableContainer
        columns={columns}
        data={quoteDetails?.items || []}
        isGlobalFilter={true}
        divClass="table-responsive table-card mb-2 bg-white"
        tableClass="align-middle table-nowrap table-borderless"
        thClass="text-grey89 fw-medium fs-14 font-primary bg-greyF5"
        theadClass="table-light"
        SearchPlaceholder="Search here"
        searchAlign="right"
        leftContent={<p className="m-0 fw-medium">Items</p>}
        showPagination={false}
        customPageSize={quoteDetails.items.length}
      />
    </div>
  );
};

export default React.memo(QuoteSummaryList);
